import React, { useState } from "react";

import VisibilitySensor from "react-visibility-sensor";
import { useTranslation } from "react-i18next";

import img1 from "../../../assets/img/esg/esgTwelve/esgTwelve.webp";

function EsgTwelve(){

    const { t } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);

    const onChange = (visibility) => {
      if (visibility) {
        setIsVisible(true);
      }
    };

    return(
        <VisibilitySensor onChange={onChange} partialVisibility minTopValue={400}>
            <div id="esgTwelve" className={`esgTwelve ${isVisible ? 'visible' : ''}`}>
                <div className={`esgImg ${isVisible ? 'visible' : ''}`}>
                    <img width={'800px'} src={img1} alt="" />
                </div>
                <div className="esgText">
                    <h1 className={`${isVisible ? 'visible' : ''}`}><span>{t("esg_twelve_title_span")}</span><br />{t("esg_twelve_title")}</h1>
                    <p className={`${isVisible ? 'visible' : ''}`}>
                        {t("esg_twelve_text")}
                    </p>
                </div>
            </div>
        </VisibilitySensor>
    )
}

export default EsgTwelve;
